"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMonthPicker = void 0;
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var theme_1 = require("../../utils/theme");
var ApButtonGroup_1 = require("../ApButtonGroup");
var ApButtons_1 = require("../ApButtons");
var ApIcon_1 = require("../ApIcon");
var ApMonthPickerGrid_1 = require("./ApMonthPickerGrid");
var types_1 = require("./types");
var utils_1 = require("./utils");
var styles_1 = require("./styles");
exports.ApMonthPicker = function (_a) {
    var srcRange = _a.srcRange, stateRange = _a.stateRange, onConfirm = _a.onConfirm, onReset = _a.onReset, className = _a.className;
    var _b = __read(react_1.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var initialRange = {
        from: {
            month: utils_1.monthNames[srcRange.from.month - 1],
            monthNumber: srcRange.from.month,
            year: srcRange.from.year,
        },
        to: {
            month: utils_1.monthNames[srcRange.to.month - 1],
            monthNumber: srcRange.to.month,
            year: srcRange.to.year,
        },
    };
    var _c = __read(react_1.useState(__assign({}, initialRange)), 2), setRange = _c[0], setSetRange = _c[1];
    var _d = __read(react_1.useState(__assign({}, initialRange)), 2), selectedRange = _d[0], setselectedRange = _d[1];
    var _e = __read(react_1.useState({
        from: {
            yearIndex: 0,
        },
        to: {
            yearIndex: 0,
        },
    }), 2), currentYear = _e[0], setCurrentYear = _e[1];
    var handleFromSelect = function (obj) {
        setselectedRange(__assign(__assign({}, selectedRange), { from: obj }));
    };
    var handleToSelect = function (obj) {
        setselectedRange(__assign(__assign({}, selectedRange), { to: obj }));
    };
    var handleConfirm = function () {
        setSetRange({ from: selectedRange.from, to: selectedRange.to });
        if (onConfirm) {
            onConfirm({ from: selectedRange.from, to: selectedRange.to });
        }
        setIsOpen(false);
    };
    var handleDismiss = function () {
        setselectedRange({ from: setRange.from, to: setRange.to });
        setIsOpen(false);
    };
    var handleOpen = function () {
        setIsOpen(true);
    };
    var handleReset = function () {
        setSetRange(__assign({}, initialRange));
        setselectedRange(__assign({}, initialRange));
        setCurrentYear({
            from: {
                yearIndex: utils_1.getYearIndexFromRange(fromCompleteRange, srcRange.from.year),
            },
            to: {
                yearIndex: utils_1.getYearIndexFromRange(toCompleteRange, srcRange.to.year),
            },
        });
        if (onReset) {
            onReset(__assign({}, initialRange));
        }
    };
    var availableData = initialRange.from.month + " " + initialRange.from.year + " - " + initialRange.to.month + " " + initialRange.to.year;
    var selectedData = setRange.from.month + " " + setRange.from.year + " - " + setRange.to.month + " " + setRange.to.year;
    var fromCompleteRange = utils_1.createSrcRange(srcRange, selectedRange.from, selectedRange.to, types_1.FROM);
    var toCompleteRange = utils_1.createSrcRange(srcRange, selectedRange.to, selectedRange.from, types_1.TO);
    react_1.useEffect(function () {
        if (stateRange) {
            setSetRange(__assign({}, stateRange));
            setselectedRange(__assign({}, stateRange));
            setCurrentYear({
                from: {
                    yearIndex: utils_1.getYearIndexFromRange(fromCompleteRange, stateRange.from.year),
                },
                to: {
                    yearIndex: utils_1.getYearIndexFromRange(toCompleteRange, stateRange.to.year),
                },
            });
        }
        else {
            setCurrentYear({
                from: {
                    yearIndex: utils_1.getYearIndexFromRange(fromCompleteRange, srcRange.from.year),
                },
                to: {
                    yearIndex: utils_1.getYearIndexFromRange(toCompleteRange, srcRange.to.year),
                },
            });
        }
    }, [stateRange]);
    var handleChangeYear = function (key, value) {
        var _a;
        setCurrentYear(__assign(__assign({}, currentYear), (_a = {}, _a[key] = {
            yearIndex: currentYear[key].yearIndex + value,
        }, _a)));
    };
    return (React.createElement(styles_1.StyledMonthPicker, { className: "ap-month-picker " + (className ? className : '') },
        React.createElement(styles_1.StyledPickerInput, { onClick: function () { return handleOpen(); } },
            React.createElement(ApIcon_1.ApIcon, { iconColor: theme_1.colors.grey4, iconName: "baseline_date_range" }),
            React.createElement("span", { style: { marginLeft: theme_1.scaffolding.sm } }, selectedData)),
        isOpen && (React.createElement(styles_1.StyledPickerBody, null,
            React.createElement(styles_1.StyledPickerHeader, null,
                React.createElement("h4", null, "Start the time period"),
                React.createElement(ApButtons_1.ApButtonIcon, { iconName: "baseline_close", onClick: function () { return handleDismiss(); } })),
            React.createElement(styles_1.StyledSubHeader, null,
                React.createElement(styles_1.StyledAvailableData, null,
                    React.createElement(ApIcon_1.ApIcon, { iconName: "outline_error", iconColor: theme_1.colors.green1 }),
                    React.createElement("h5", { style: { color: theme_1.colors.green1 } }, "Available Data:"),
                    React.createElement("h5", null, availableData)),
                React.createElement(ApButtons_1.ApButtonSecondary, { onClick: function () { return handleReset(); } }, "RESET")),
            React.createElement(styles_1.StyledMonthGroup, null,
                React.createElement(ApMonthPickerGrid_1.ApMonthPickerGrid, { completedSrcRange: fromCompleteRange, handleSelect: function (obj) { return handleFromSelect(obj); }, handleDeIncYear: function () { return handleChangeYear(types_1.FROM, -1); }, handleIncYear: function () { return handleChangeYear(types_1.FROM, 1); }, selectDirection: types_1.FROM, currentYear: currentYear.from.yearIndex }),
                React.createElement("span", { style: {
                        border: "1px solid " + theme_1.colors.grey2,
                        margin: "0px " + theme_1.scaffolding.md,
                    } }),
                React.createElement(ApMonthPickerGrid_1.ApMonthPickerGrid, { completedSrcRange: toCompleteRange, handleSelect: function (obj) { return handleToSelect(obj); }, handleDeIncYear: function () { return handleChangeYear(types_1.TO, -1); }, handleIncYear: function () { return handleChangeYear(types_1.TO, 1); }, selectDirection: types_1.TO, currentYear: currentYear.to.yearIndex })),
            React.createElement(styles_1.StyledPickerFooter, null,
                React.createElement(ApButtonGroup_1.ApButtonGroup, { justifyContent: "space-between" },
                    React.createElement(ApButtons_1.ApButtonSecondary, { onClick: function () { return handleDismiss(); } }, "Cancel"),
                    React.createElement(ApButtons_1.ApButtonMain, { onClick: function () { return handleConfirm(); } }, "Apply")))))));
};
//# sourceMappingURL=ApMonthPicker.js.map